<template>
  <span>
      <v-dialog
        v-model="loginDialog"
        max-width="290"
      >
        <LoginModal @loggedIn="closeModals"></LoginModal>
      </v-dialog>

      <v-dialog
        v-model="signupDialog"
        max-width="290"
      >
        <SignupModal @signedUp="closeModals"></SignupModal>
      </v-dialog>
    <v-navigation-drawer app v-model="drawer" dark disable-resize-watcher>
        <v-list>
            <template>
              <v-list-item>
                <v-list-item-content>
                    <router-link class="navbarLink" to="/tours">
                        {{ $t('appNavigation.tours') }}
                    </router-link>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
            <template>
                <v-list-item>
                  <v-list-item-content>
                      <router-link class="navbarLink" to="/about">
                          {{ $t('appNavigation.aboutUs') }}
                      </router-link>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
            <template>
                <v-list-item>
                  <v-list-item-content>
                      <router-link class="navbarLink" to="/tours">
                          {{ $t('appNavigation.contact') }}
                      </router-link>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
            <template>
                <v-list-item>
                  <v-list-item-content v-if="!isAuthenticated" @click.stop="loginDialog = true">
                      Login
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
            <template>
                <v-list-item>
                  <v-list-item-content v-if="!isAuthenticated" @click.stop="signupDialog = true">
                      Sign Up
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
        </v-list>
    </v-navigation-drawer>
    <v-app-bar>
        <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-spacer class="hidden-md-and-up"></v-spacer>
        <router-link to="/">
            <img id="logo" src="../../assets/logo.png">
        </router-link>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-spacer class="hidden-md-and-up"></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn text to="/tours">{{ $t('appNavigation.tours') }}</v-btn>
          <v-btn text to="/about">{{ $t('appNavigation.aboutUs') }}</v-btn>
          <v-btn text to="/contact">{{ $t('appNavigation.contact') }}</v-btn>
        </v-toolbar-items>
      <div class="ml-3">
          <div v-for="entry in languages" @click="changeLocale(entry.language)" >
              <flag v-ripple class="elevation-2" :iso="entry.flag" v-bind:squared="false" />
          </div>
      </div>
    </v-app-bar>
  </span>
</template>

<script>
import LoginModal from '../modal/LoginModal.vue'
import SignupModal from '../modal/SignupModal.vue'
import i18n from '@/plugins/i18n';

export default {
    name: 'AppNavigation',
    components: {
        LoginModal,
        SignupModal
    },

    data: () => ({
        drawer: false,
        items: [
            { title: 'Tours',
                url: '/tours' },
            { title: 'About Us',
                url: '/about' },
            { title: 'Contact',
                url: '/contact'  }
          ],
        loginDialog: false,
        signupDialog: false,
        languages: [
            { flag: 'us', language: 'en', title: 'English' },
            { flag: 'kr', language: 'kr', title: 'Korean' }
        ]
    }),
    computed: {
        isAuthenticated() {
            return this.$store.state.isAuthenticated;
        },
        accountID() {
            return this.$store.state.user.user.email
        }

    },
    methods: {
        logout() {
            this.$store.dispatch('userSignOut');
        },
        closeModals() {
            this.loginDialog = false;
            this.signupDialog = false;
        },
        changeLocale(locale) {
            i18n.locale = locale;
        }

    }
};
</script>

<style>
#logo {
  height: 55px;
  margin-top: 8px;
}
.navbarLink {
    color: white !important;
    text-decoration: none;
}
</style>
